import { useEffect, useState } from "react";
import { useLenis } from "../providers/LenisProvider";

/**
 * Zwraca postęp scrolla całej strony jako liczbę 0–1.
 * Jeśli Lenis jest aktywny, słucha jego eventu "scroll" (płynniejsze wartości
 * niż natywny scroll event). Jeśli Lenis jest wyłączony (reduced motion),
 * spada na natywny window.scroll.
 */
export function useScrollProgress(): number {
  const lenis = useLenis();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    function computeNative() {
      const scrollTop = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? Math.min(scrollTop / max, 1) : 0);
    }

    if (lenis) {
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        setProgress(max > 0 ? Math.min(lenis.scroll / max, 1) : 0);
      };
      lenis.on("scroll", onScroll);
      return () => lenis.off("scroll", onScroll);
    }

    computeNative();
    window.addEventListener("scroll", computeNative, { passive: true });
    window.addEventListener("resize", computeNative);
    return () => {
      window.removeEventListener("scroll", computeNative);
      window.removeEventListener("resize", computeNative);
    };
  }, [lenis]);

  return progress;
}
